import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackBar, hideSnackBar } from '../../redux/Slices/snackbarSlice';

const NetworkStatus = () => {
    const dispatch = useDispatch();

    const checkConnectionSpeed = async () => {
        try {
            const lastShown = localStorage.getItem('slow_connection_warning_shown_at');
            const now = Date.now();

            // If it's shown within last 24 hours, skip
            if (lastShown && now - parseInt(lastShown) < 24 * 60 * 60 * 1000) {
                return;
            }

            const navigation = performance?.getEntriesByType('navigation')[0];
            const connection = navigator?.connection || navigator?.mozConnection || navigator?.webkitConnection;

            let showWarning = false;

            if (connection?.downlink) {
                if (connection.downlink < 1) {
                    showWarning = true;
                }
            } else if (navigation) {
                if (navigation.duration > 3000) {
                    showWarning = true;
                }
            }

            if (showWarning) {
                dispatch(showSnackBar({
                    message: 'Slow internet connection detected',
                    type: 'warning'
                }));
                localStorage.setItem('slow_connection_warning_shown_at', now.toString());
            }
        } catch (error) {
            console.error('Error checking connection speed:', error);
        }
    };

    useEffect(() => {
        const handleOnline = () => {
            dispatch(showSnackBar({
                message: 'Internet connection restored',
                type: 'success'
            }));
            setTimeout(() => dispatch(hideSnackBar()), 3000);
            checkConnectionSpeed(); // Check speed when connection is restored
        };

        const handleOffline = () => {
            dispatch(showSnackBar({
                message: 'No internet connection',
                type: 'error'
            }));
        };

        const handleConnectionChange = () => {
            if (navigator.onLine) {
                checkConnectionSpeed();
            }
        };

        // Initial check
        if (navigator.onLine) {
            checkConnectionSpeed();
        }

        // Set up event listeners
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Listen for connection changes if the API is available
        if (navigator?.connection) {
            navigator.connection.addEventListener('change', handleConnectionChange);
        }

        // Periodically check connection speed while online
        const speedCheckInterval = setInterval(() => {
            if (navigator.onLine) {
                checkConnectionSpeed();
            }
        }, 30000); // Check every 30 seconds

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            if (navigator?.connection) {
                navigator.connection.removeEventListener('change', handleConnectionChange);
            }
            clearInterval(speedCheckInterval);
        };
    }, [dispatch]);

    return null;
};

export default NetworkStatus;